module.exports = __webpack_public_path__ + "img/thumbnail_Dingo_m_normal.f7b46f02.png";